import React from 'react'
import { ArrowCaret } from '@fs/zion-icon'
import ExitDoorIcon from './ExitDoorIcon'
import GridSquaresIcon from './GridSquaresIcon'
import NineDotIcon from './NineDotIcon'
import { NAV_ROW_KINDS } from './navigationModel'

// One glyph per row the card supplies itself (experiences illustrate their own
// destination rows). The card draws these in its rows, and the handle wears
// one when that row is all the card would hold - so a row looks the same
// wherever it appears. The waffle means "the level above, inside this
// experience"; the squares mean "out to every experience"; the two must not
// look alike.
const NAV_ROW_GLYPHS = {
  [NAV_ROW_KINDS.BACK]: <ArrowCaret direction="backward" size="sm" aria-hidden />,
  [NAV_ROW_KINDS.PARENT]: <NineDotIcon />,
  [NAV_ROW_KINDS.HOME]: <GridSquaresIcon />,
  [NAV_ROW_KINDS.KIDS_RETURN]: <GridSquaresIcon />,
  [NAV_ROW_KINDS.LEAVE_KIOSK]: <ExitDoorIcon />,
}

export default NAV_ROW_GLYPHS
